export function searchItemView(
  itemViews,
  entities,
  hitDetection,
  absolutePoint,
) {
  let index = itemViews.length - 1

  while (index > -1) {
    const itemView = itemViews[index]
    index -= 1

    if (itemView.deleted) continue
    if (itemView.params.isUndeletable) continue
    if (!entities.includes(itemView.entity)) continue

    const status = hitDetection(
      {
        width: itemView.boundary.width,
        height: itemView.boundary.height,
        angle: itemView.boundary.angle,
      },
      {
        x: absolutePoint.x - itemView.boundary.x,
        y: absolutePoint.y - itemView.boundary.y,
      },
    )

    if (status) return itemView
  }

  return null
}

export function searchResizeCorner(
  itemViews,
  entities,
  hitDetection,
  absolutePoint,
) {
  let index = itemViews.length - 1

  while (index > -1) {
    const itemView = itemViews[index]
    index -= 1

    if (itemView.deleted) continue
    if (itemView.params.isUndeletable) continue
    if (!entities.includes(itemView.entity)) continue

    const status = hitDetection(
      {
        width: itemView.boundary.width,
        height: itemView.boundary.height,
        angle: itemView.boundary.angle,
      },
      {
        x: absolutePoint.x - itemView.boundary.x,
        y: absolutePoint.y - itemView.boundary.y,
      },
    )

    if (status) return { status, itemView }
  }

  return { status: null, itemView: null }
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseDown/utils.js